/**
 * Browser polyfills for Node builtins used by crypto/sha dependencies.
 */
import { Buffer } from 'buffer';

(window as any).Buffer = (window as any).Buffer || Buffer;
